// extracted by mini-css-extract-plugin
export default {"container":"Qc9VCdc1YNI5Yi457hV6","loaderContainer":"KWN4MEaZLhUZv5W4cmbP"};